"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sdsToastStateServiceDIKey = exports.sdsToastDataClientDIKey = void 0;
const sdsToastStateServiceDIKey = "sds_toast_state_service_v1";
exports.sdsToastStateServiceDIKey = sdsToastStateServiceDIKey;
const sdsToastDataClientDIKey = "sds_toast_data_client_v1";
exports.sdsToastDataClientDIKey = sdsToastDataClientDIKey;
//# sourceMappingURL=sdsToastStateServiceDiKeys.js.map